<template lang="pug">
v-expand-transition
  v-card(dark max-width="580").sdo-card.secondary
    v-card-text.pb-0.px-3
      v-row.ma-0
        v-btn(
          :disabled="type === TYPES.archive"
          small color="white" outlined
          @click="readAll"
        ) Прочитать все
        v-spacer
        v-btn-toggle(
          light
          mandatory
          :loading="loading"
          v-model="type" outlined small
        )
          v-btn(:value="TYPES.all" small :loading="loading" ) Не прочитанные
          v-btn(:value="TYPES.archive" outlined small :loading="loading") Архив
      v-list.secondary(outlined width="550" max-height="640").overflow-auto.scroll
        v-skeleton-loader(
          v-if="loading"
          type="list-item@3"
        )
        v-list-item(v-else-if="!notifications.length"  outlined)
          v-list-item-content Новых уведомлений не найдено...
        v-slide-x-transition(
          v-for="(n, idx) in notifications"
          :key="idx"
        )
          v-list-item.mb-1.secondary.lighten-1(
            outlined
            rounded
          )
            v-list-item-content(v-html="n.message")

            v-list-item-action(
            )
              router-link.text-decoration-none(
                v-if="n.course_id"
                :to="{ name: 'CourseView', params: { id: n.course_id } }"
              )
                v-icon(small) mdi-eye
              v-icon(small v-else) mdi-information-variant
              tooltip-wrap(
                :value="!n.wasRead"
                text="Отметить как прочитанное"
              )
                v-btn(icon :disabled="n.wasRead" @click="readNotification([n.id])")
                  v-icon {{n.wasRead ? 'mdi-eye-off' : 'mdi-eye' }}
</template>

<script>
export default {
  name: 'NotificationBadgeItems',
  props: {
    notifications: { type: Array, default: () => ([]) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      type: 0,
      TYPES: {
        all: 0,
        archive: 1,
      },
    };
  },
  watch: {
    type(val) {
      this.$emit('update', val);
    },
  },
  methods: {
    readAll() {
      const ids = this.notifications.map((i) => i.id);
      this.readNotification(ids);
    },
    readNotification(ids) {
      const payload = {
        ids,
      };
      this.$api.notifications.readNotification(payload);
      this.$emit('read', ids);
    },
  },
};
</script>
